module.exports = __webpack_public_path__ + "images/feature/template-1-ca83aa1a77f24fe9dca0439f977dde58.jpg";